module.exports = __webpack_public_path__ + "static/media/404.b519ecbe.png";